/**
 * Electrical Equipment Guidance - Simple Direct Pattern
 * Uses requirement ID mapping from electrical.simple.js
 */

import { ELECTRICAL_GUIDANCE } from "./electrical.simple";

/**
 * Get Electrical Equipment Guidance
 * @param {string} itemId - Equipment requirement ID
 * @returns {Object|null} Guidance object or null
 */
export function getElectricalGuidance(itemId) {
  // Early return - no debug logging for missing guidance
  return ELECTRICAL_GUIDANCE[itemId] || null;
}